import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageHealthWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "averageHealth",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_2512",
		"data-name": "Path 2512",
		d: "M0,0H24V24H0Z",
		fill: "none"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Group_17159",
		"data-name": "Group 17159",
		transform: "translate(1.861 0.789)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_17160",
				"data-name": "Group 17160",
				transform: "translate(8.662 15.535)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_12717",
					"data-name": "Path 12717",
					d: "M11.039,13.026h0a1.552,1.552,0,0,1,2.2,0L15.806,15.6a1.553,1.553,0,0,1-2.2,2.2l-2.571-2.571A1.552,1.552,0,0,1,11.039,13.026Z",
					transform: "translate(-10.584 -12.571)",
					fill: "none",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeWidth: 1.5
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_12722",
					"data-name": "Path 12722",
					d: "M0,2.169,2.169,0",
					transform: "translate(1.754 1.753)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_17163",
				"data-name": "Group 17163",
				transform: "translate(11.5 15.534) rotate(-45)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_12717-2",
					"data-name": "Path 12717",
					d: "M.455.455h0a1.552,1.552,0,0,1,2.2,0L5.222,3.026a1.553,1.553,0,0,1-2.2,2.2L.455,2.651A1.552,1.552,0,0,1,.455.455Z",
					fill: "none",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeWidth: 1.5
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_12722-2",
					"data-name": "Path 12722",
					d: "M0,2.169,2.169,0",
					transform: "translate(1.754 1.753)",
					fill: "none",
					stroke: "#fff",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12720",
				"data-name": "Path 12720",
				d: "M6.285,19.565H2.679A1.928,1.928,0,0,1,.75,17.637V7.519A1.928,1.928,0,0,1,2.679,5.59h7.373A1.928,1.928,0,0,1,11.98,7.519v3.253",
				transform: "translate(0 0.228)",
				fill: "none",
				stroke: "#fff",
				strokeLinecap: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12721",
				"data-name": "Path 12721",
				d: "M3.507.75H9.183c1.107,0,1.552.9,1.552,2.005a.765.765,0,0,1-.765.765H2.643a.764.764,0,0,1-.765-.765C1.878,1.647,2.4.75,3.507.75Z",
				transform: "translate(0.058 0.461)",
				fill: "none",
				stroke: "#fff",
				strokeLinecap: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_17164",
				"data-name": "Group 17164",
				transform: "translate(0.298 0.298)",
				children: [/* @__PURE__ */ _jsx("line", {
					id: "Line_143",
					"data-name": "Line 143",
					y2: 4,
					transform: "translate(6.067 10.508)",
					fill: "none",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeWidth: 1.5
				}), /* @__PURE__ */ _jsx("line", {
					id: "Line_144",
					"data-name": "Line 144",
					x1: 4,
					transform: "translate(4.067 12.507)",
					fill: "none",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_145",
				"data-name": "Line 145",
				y2: 1.389,
				transform: "translate(3.842 3.981)",
				fill: "none",
				stroke: "#fff",
				strokeLinecap: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_146",
				"data-name": "Line 146",
				y2: .681,
				transform: "translate(8.889 4.408)",
				fill: "none",
				stroke: "#fff",
				strokeLinecap: "round",
				strokeWidth: 1.5
			})
		]
	})]
});
export default SvgAverageHealthWhite;
